import React from 'react';
import Icon from '../../../../../components/icons/Icon';
import { createTag } from '../../../../../element/tags/tagsService';
import { TagsToolbarPopupProps } from './popup/TagsToolbarPopup';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { getElementId, getTitle } from '../../../../../../common/elements/utils/elementPropertyUtils';

type Props = TagsToolbarPopupProps & {
    shareRootPath?: ImMNElement[];
    searchString: string;
    setSearchString: (name: string) => void;
    fetchTags: () => void;
};

const TagsCreateButtons = (props: Props) => {
    const { shareRootPath, currentBoardId, searchString, setSearchString, currentUserId, fetchTags } = props;

    if (!shareRootPath) return null;

    const handleCreateTag = (rootBoardId = currentBoardId) => {
        if (!searchString) return;

        createTag(searchString, currentUserId, rootBoardId).then(fetchTags);
        setSearchString('');
    };

    return (
        <ul className="TagsCreateButtons mt-2">
            {shareRootPath.map((board, index) => {
                const elementId = getElementId(board);
                return (
                    <li
                        key={elementId}
                        className={` flex flex-row cursor-pointer`}
                        onClick={() => handleCreateTag(elementId)}
                        style={{ marginLeft: `${index * 2}rem` }}
                    >
                        <Icon name="plus" />
                        <span className={`text-left ml-1`}>
                            New tag in
                            {'\u00A0'}
                            <span className="font-bold">{getTitle(board)}</span>
                        </span>
                    </li>
                );
            })}
        </ul>
    );
};

export default TagsCreateButtons;
